import BulkVehicleTypePanel from './bulk-vehicle-type-panel';

export default BulkVehicleTypePanel;
